import { canUseDOM } from './canUseDom';

export const getWindow = () => (canUseDOM ? window : undefined);
